import { defaultDetail } from '../VenueDetail';
import {
  getConsecutiveEqualDays,
  parseFromTimeFramesKey,
  sortedDays,
  splitHoursStringWithTwoDots,
} from './utils';
import VenueOpeningHoursEditMode from './VenueOpeningHoursEditMode';

const t = {
  weekDayMap: {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
  },
  closed: 'Closed',
  to: 'to',
  and: 'and',
};

const HoursDetails = ({ hoursArray }) => {
  if (!hoursArray?.length) {
    return t.closed;
  }

  return (
    <div className="detailed-hours">
      {hoursArray.map((detail, key) => (
        <span key={`${detail?.from}-${detail?.to}}`}>
          {splitHoursStringWithTwoDots(detail.from)}-{splitHoursStringWithTwoDots(detail.to)}
          {key !== hoursArray.length - 1 && <>,</>}
        </span>
      ))}
    </div>
  );
};

const GroupedHoursItem = ({ consecutiveEqualDays, timeFramesKey }) => {
  const arrayOfDays = consecutiveEqualDays[timeFramesKey];
  const daysLabel = arrayOfDays.map((day) => t.weekDayMap[day]).join(', ');

  return (
    <div className="venue-detail-hours">
      <div className="week-day">{daysLabel}</div>
      <div>
        <HoursDetails hoursArray={parseFromTimeFramesKey(timeFramesKey)} />
      </div>
    </div>
  );
};

const GroupedHours = ({ consecutiveEqualDays }) => {
  const consecutiveDaysArray = Object.keys(consecutiveEqualDays);
  return (
    <div>
      {consecutiveDaysArray.map((timeFramesKey) => (
        <GroupedHoursItem
          key={timeFramesKey}
          consecutiveEqualDays={consecutiveEqualDays}
          timeFramesKey={timeFramesKey}
        />
      ))}
    </div>
  );
};

const VenueOpeningHoursRenderer = ({ isEditing, fieldName, error, timeFrames, value }) => {
  if (isEditing) {
    return <VenueOpeningHoursEditMode schedules={value} error={error} fieldName={fieldName} />;
  }
  if (!timeFrames) {
    return defaultDetail;
  }

  const dayKeys = Object.keys(timeFrames);

  if (!dayKeys?.length) {
    return defaultDetail;
  }

  const sortedDaysByKey = [...dayKeys].sort(sortedDays);
  const consecutiveEqualDays = getConsecutiveEqualDays(sortedDaysByKey, timeFrames);

  return (
    <div>
      <GroupedHours consecutiveEqualDays={consecutiveEqualDays} />
    </div>
  );
};

export default VenueOpeningHoursRenderer;
